// Constants used only by the shared feedback components.

export const FEEDBACK_TYPE = {
    PRODUCT: "product",
    SUMMARY: "summary",
    IN_MEETING_EXP: "inMeetingExp"
}

export const FEEDBACK_MODAL_HEADER = {
    PRODUCT: "How was your experience with Amazon Meetings?",
}

export const FEEDBACK_MESSAGE = {
    SUBMITTED: "Thank you. All feedback is a gift",
    NOT_SUBMITTED: "No feedback has been provided"
};

export const FEEDBACK_REASON = {
    NOT_ACCURATE: "Summary isn't accurate",
    NOT_COMPLETE: "Summary isn't complete",
    BLOCKED: "Summary shouldn't be blocked"
};

export const FEEDBACK_MODAL_STAGE = {
    RATING: "rating",
    COMMENT: "comment",
    SUBMITTED: "submitted",
}

export const BUTTON_HEIGHT_SMALL = 26.6923;

export const BUTTON_MIN_WIDTH = 38;